// F4 Report 7: Cutlist Done, Factory Plan Not Created
import React, { useEffect, useState } from "react";
import { fetchReportCutlistDoneNoPlan } from "../../api/service";
import ReportShell, { display, downloadReportCsv } from "./ReportShell";

const CutlistDoneReport = () => {
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    fetchReportCutlistDoneNoPlan()
      .then((res) => { if (!alive) return; setRows(res?.rows || []); setCount(res?.count || 0); })
      .catch((e) => alive && setError(e?.message || "Failed to load"))
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, []);

  return (
    <ReportShell
      title="7. Cutlist Done, Factory Plan Not Created"
      count={count}
      loading={loading}
      error={error}
      onExport={() => downloadReportCsv("exec_cutlist_done_no_plan")}
    >
      <div className="table-responsive">
        <table className="table table-bordered table-hover align-middle">
          <thead className="table-light">
            <tr>
              <th className="text-center">Project</th>
              <th className="text-center">Ageing (days)</th>
              <th className="text-center">Delay Insurance</th>
              <th className="text-center">Execution Centre</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={4} className="text-center text-muted py-4">Nothing to report.</td></tr>
            ) : rows.map((r) => (
              <tr key={r.project_id}>
                <td className="text-center">{r.project_label}</td>
                <td className="text-center">{display(r.ageing_days)}</td>
                <td className="text-center">{r.delay_insurance === true ? "Yes" : r.delay_insurance === false ? "No" : "-"}</td>
                <td className="text-center">{r.execution_centre ? r.execution_centre.charAt(0).toUpperCase() + r.execution_centre.slice(1) : "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </ReportShell>
  );
};

export default CutlistDoneReport;
